import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import * as THREE from 'three';
const registry = {};
export function registerFiller(code, component) {
    registry[code] = component;
}
// ─── FillerRenderer ───────────────────────────────────────────────────────────
export const FillerRenderer = ({ code, props }) => {
    const Component = registry[code];
    if (!Component) {
        console.warn(`[FillerRenderer] Unknown filler type: "${code}"`);
        return null;
    }
    return _jsx(Component, { ...props });
};
const LatticeBar = ({ x, y, z, width, height, depth, color }) => (_jsxs("mesh", { position: [x, y, z], children: [_jsx("boxGeometry", { args: [width, height, depth] }), _jsx("meshStandardMaterial", { color: color })] }));
const Lattice = ({ cols, rows, stepX, stepY, profileWidth, color }) => {
    const colorObj = useMemo(() => new THREE.Color(color), [color]);
    const depth = profileWidth;
    const totalWidth = cols * stepX + profileWidth;
    const totalHeight = rows * stepY + profileWidth;
    const verticalBars = useMemo(() => {
        const bars = [];
        for (let c = 0; c <= cols; c++) {
            const x = -totalWidth / 2 + profileWidth / 2 + c * stepX;
            bars.push({ x, y: 0, key: `v-${c}` });
        }
        return bars;
    }, [cols, stepX, totalWidth, profileWidth]);
    const horizontalBars = useMemo(() => {
        const bars = [];
        for (let r = 0; r <= rows; r++) {
            const y = -totalHeight / 2 + profileWidth / 2 + r * stepY;
            bars.push({ y, key: `h-${r}` });
        }
        return bars;
    }, [rows, stepY, totalHeight, profileWidth]);
    return (_jsxs("group", { children: [verticalBars.map(({ x, key }) => (_jsx(LatticeBar, { x: x, y: 0, z: 0, width: profileWidth, height: totalHeight, depth: depth, color: colorObj }, key))), horizontalBars.map(({ y, key }) => (_jsx(LatticeBar, { x: 0, y: y, z: 0, width: totalWidth, height: profileWidth, depth: depth, color: colorObj }, key)))] }));
};
registerFiller('lattice', Lattice);
const Glass = ({ width, height, opacity, color, thickness }) => {
    const colorObj = useMemo(() => new THREE.Color(color), [color]);
    return (_jsxs("mesh", { children: [_jsx("boxGeometry", { args: [width, height, thickness] }), _jsx("meshPhysicalMaterial", { color: colorObj, transparent: true, opacity: opacity, roughness: 0, metalness: 0, transmission: 0.9, thickness: thickness * 100, side: THREE.DoubleSide, depthWrite: false })] }));
};
registerFiller('glass', Glass);
const Polycarbonate = ({ panels, actualPanelWidth, height, color, opacity, }) => {
    const colorObj = useMemo(() => new THREE.Color(color), [color]);
    const totalWidth = panels * actualPanelWidth;
    const gap = 0.005; // зазор между панелями
    const thickness = 0.01;
    return (_jsx("group", { children: Array.from({ length: panels }).map((_, i) => {
            const x = -totalWidth / 2 + actualPanelWidth * i + actualPanelWidth / 2;
            return (_jsxs("mesh", { position: [x, 0, 0], children: [_jsx("boxGeometry", { args: [actualPanelWidth - gap, height, thickness] }), _jsx("meshPhysicalMaterial", { color: colorObj, transparent: true, opacity: opacity, roughness: 0.1, metalness: 0, side: THREE.DoubleSide, depthWrite: false })] }, i));
        }) }));
};
registerFiller('polycarbonate', Polycarbonate);
